import {Component, Input} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IYii} from '../../../../globals';
import {CommonModule} from '@angular/common';
import {Checkbox} from 'primeng/checkbox';
import {Message} from 'primeng/message';

declare var Yii: IYii;

@Component({
  selector: 'ng-field-file',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    Checkbox,
    Message
  ],
  template: `
    <div class="form-row flex-align-center" style="height: 24px">
      <label></label>
      <div class="flex-row gap-16px flex-align-center">
        <p-checkbox [(ngModel)]="field.multiple_upload" binary="true"/>
        <label>{{ Yii.t('app', 'Multiple File Upload') }}</label>
        @if (field.multiple_upload) {
            <p-message size="small" severity="success">
              {{ Yii.t('app', 'Only on Android and Web clients') }}
            </p-message>
        }
      </div>
    </div>
  `,
})
export class FieldFile {
  Yii = Yii;
  @Input() field: any;
}
